import { useFetchMembershipStatus } from '@/api/hooks/useFetchMembershipStatus'
import { analytics } from '@/lib/analytics'
import { Button, ButtonText } from '@/ui/core/button'
import { Header } from '@/ui/core/header'
import { Screen } from '@/ui/core/screen'
import { HStack, VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import * as Linking from 'expo-linking'
import { Redirect } from 'expo-router'
import { Platform } from 'react-native'

const SUPPORT_PHONE_NUMBER = '+18339292559'

const InactiveMembershipScreen = () => {
	const { hasActiveMembership } = useFetchMembershipStatus()
	const onSupportTextButtonPressed = () => {
		const separator = Platform.OS === 'ios' ? '&' : '?'

		analytics.trackClick('reactivate_membership_button_pressed')
		Linking.openURL(`sms:${SUPPORT_PHONE_NUMBER}${separator}body=RESTART`)
	}

	const isMobileDevice = Platform.OS === 'android' || Platform.OS === 'ios'

	if (hasActiveMembership) {
		return <Redirect href="/" />
	}

	return (
		<HStack fullHeight>
			<Screen preset="fixed" className="flex flex-1">
				<VStack className="justify-center items-center h-full gap-8">
					<Header className="text-center max-w-[60%]" variant="h2">
						Your Wally membership is inactive.
					</Header>
					<Text className="text-pretty text-center max-w-[40%] text-palette_6">
						Don't worry though! We're here to help. Text back RESTART for help
						reactivating your membership to {'\n'} 833-929-2559.
					</Text>
					{isMobileDevice && (
						<Button onPress={onSupportTextButtonPressed}>
							<ButtonText>Reactivate Membership</ButtonText>
						</Button>
					)}
				</VStack>
			</Screen>
		</HStack>
	)
}

export default InactiveMembershipScreen
